<template>
    <div>
        <PageHeader
            title="WisdomShots"
            :color="'#342a12'"
            :image="asset('images/helpers/me-vlogs.png')"
            :background="asset('images/helpers/vlogs-bg.webp')"
            description="I produce short videos with the intention of helping improve your daily life through relatable stories, fresh ideas, and useful resources. I hope that some of the lessons from my videos will positively impact your life in some way."
        >
            <SearchBar
                @onSubmit="searchSubmit"
                @onClear="searchCleared"
                v-model="searchInput"
            />
        </PageHeader>
        <Container>
            <div class="list" v-if="data.data.length > 0">
                <Item v-for="item in data.data" :key="item.id" :data="item" />
            </div>
            <NoData title="No vlogs found" v-else>
                <span></span>
            </NoData>
            <Pagination
                :rawData="data.meta"
                :onClick="pageChange"
                class="mt-4"
            />
        </Container>
        <VlogPlayer />
    </div>
</template>
<script>
import Item from "./item.vue";
import VlogPlayer from "../shared/vlogPlayer.vue";
import PageHeader from "../shared/pageHeader.vue";

export default {
    components: {
        Item,
        VlogPlayer,
        PageHeader,
    },
    props: {
        data: {
            type: Object,
            default: () => ({}),
        },
        search: {
            type: String,
            default: "",
        },
    },
    watch: {
        search: {
            immediate: true,
            handler(value) {
                this.searchInput = value;
            },
        },
    },
    data() {
        return {
            searchInput: "",
        };
    },
    methods: {
        searchSubmit(search) {
            this.$root.$emit("hold-transition", null);
            this.$inertia.visit(
                this.$route(this.$route().current(), {
                    search: search,
                    page: 1,
                })
            );
        },
        searchCleared() {
            this.$root.$emit("hold-transition", null);
            this.$inertia.visit(
                this.$route(this.$route().current(), {
                    search: "",
                    page: 1,
                })
            );
        },
        pageChange(page) {
            this.$root.$emit("hold-transition", null);
            this.$inertia.visit(
                this.$route(this.$route().current(), {
                    page: page,
                    search: this.searchInput,
                })
            );
        },
    },
};
</script>
<style lang="scss" scoped>
.list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    grid-gap: 1.4rem;
}
</style>
